import { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { ArrowUpRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';

const API = process.env.REACT_APP_BACKEND_URL;
const CATS = [['defects', 'Building defects'], ['amenities', 'Common areas & amenities'], ['parking', 'Parking'], ['safety', 'Safety & services']];

// FBC admins: which flats marked this issue, and moving a shared pattern to Post Possession (no owner named).
export default function AdminPatternPanel({ projectId, topicKey, total }) {
  const [flats, setFlats] = useState(null);
  const [form, setForm] = useState({ title: '', category: 'defects', summary: '' });
  const base = `${API}/api/topics/${projectId}/${topicKey}/affected`;
  useEffect(() => { axios.get(`${base}/flats`).then((r) => setFlats(r.data)).catch(() => setFlats(null)); }, [base, total]);
  const promote = () => axios.post(`${base}/promote`, form)
    .then(() => { toast.success('Moved to Post Possession as a common issue'); setForm({ title: '', category: 'defects', summary: '' }); })
    .catch((e) => toast.error(e.response?.data?.detail || 'Could not move'));
  if (!flats) return null;
  return (
    <div className="border-t pt-3 space-y-2" data-testid="admin-pattern-panel">
      <p className="text-xs font-semibold">FBC admin only</p>
      <p className="text-xs" data-testid="admin-pattern-flats">
        Flats that marked this: {flats.units.length ? flats.units.join(', ') : 'none yet'}
        {flats.without_unit > 0 && ` (+${flats.without_unit} without a flat on record)`}
      </p>
      <p className="text-xs text-muted-foreground">If many flats share the same problem, move it to Post Possession. The group then raises it with the developer as a common issue, and no owner is named.</p>
      <Input value={form.title} onChange={(e) => setForm({ ...form, title: e.target.value })} placeholder="e.g. Seepage at living-room window, Wing 9"
        className="h-8 text-sm bg-background" data-testid="admin-pattern-title" />
      <select value={form.category} onChange={(e) => setForm({ ...form, category: e.target.value })}
        className="h-8 w-full rounded-md border bg-background px-2 text-sm" data-testid="admin-pattern-category">
        {CATS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <Textarea rows={2} value={form.summary} onChange={(e) => setForm({ ...form, summary: e.target.value })}
        placeholder="Short factual description (optional)" className="text-sm bg-background" data-testid="admin-pattern-summary" />
      <Button size="sm" className="h-7" disabled={!form.title.trim()} onClick={promote} data-testid="admin-pattern-promote">
        <ArrowUpRight className="h-3.5 w-3.5 mr-1" />Move to Post Possession
      </Button>
    </div>
  );
}
